import { render, staticRenderFns } from "./iphone.vue?vue&type=template&id=6be5e784&scoped=true"
import script from "./iphone.vue?vue&type=script&lang=js"
export * from "./iphone.vue?vue&type=script&lang=js"
import style0 from "./iphone.vue?vue&type=style&index=0&id=6be5e784&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be5e784",
  null
  
)

export default component.exports